import React from 'react'
import { Route, IndexRoute } from 'react-router'
import App from './components/App'
import Auth from './components/Auth'
import Create from './components/create/Container'
import Main from './components/main/Main'
import NotFound from './components/404/NotFound'
import Polls from './components/polls/Container'
import Results from './components/results/Container'
import Send from './components/send/Container'
import Settings from './components/settings/Container'
import Vote from './components/vote/Container'
import VoteSuccess from './components/vote/Success'

export default (
	<Route path="/" component={App}>
		<IndexRoute component={Main} />
		<Route component={Auth}>
			<Route path="/create" component={Create} />
			<Route path="/polls" component={Polls} />
			<Route path="/:pollId/results" component={Results} />
			<Route path="/:pollId/send" component={Send} />
			<Route path="/:pollId/vote/success" component={VoteSuccess} />
			<Route path="/:pollId" component={Vote} />
			<Route path="/:pollId/settings" component={Settings} />
		</Route>
		<Route path="*" component={NotFound} />
	</Route>
)



// WEBPACK FOOTER //
// ./src/routes.jsx